import { render } from "./sub-menu-coming-soon.vue?vue&type=template&id=44d3cc8e"
import script from "./sub-menu-coming-soon.vue?vue&type=script&lang=js"
export * from "./sub-menu-coming-soon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__